@if (!featureFlagService.isAvailable('AI_CONFIG') || !aiStyle) {
  <span [ngClass]="{ 'marker-pill': withName }" class="marker-span">
    <!-- show button if can click -->
    @if (showButton) {
      <button
        class="marker-icon clickable"
        [attr.aria-label]="getLabel(marker)"
        [matTooltip]="marker.tag_name"
        [disabled]="disabled"
        (click)="select.emit()"
        [ngStyle]="{
         'color': bestContrast(),
         'background-color': '#' + marker.tag_color
        }">
        <span>{{marker.tag_abbreviation ? marker.tag_abbreviation : marker.tag_name | twoLetters}}</span>
      </button>
    } @else {
      <span
        tabindex="0"
        class="marker-icon"
        [attr.aria-label]="withName ? '' : getLabel(marker)"
        [matTooltip]="marker.tag_name"
        [ngStyle]="{
         'color': aiStyle ? '#000000' : bestContrast(),
         'background-color': aiStyle ? '#ffffff' : '#' + marker.tag_color,
         'border-color': aiStyle ? '#' + marker.tag_color : 'transparent'
        }">
        <!-- TODO remove aiStyle from ngStyles above when AI_CONFIG is available as aiStyle is completely separate -->
	        <span aria-hidden="true">{{marker.tag_abbreviation ? marker.tag_abbreviation : marker.tag_name | twoLetters}}</span>
	      </span>
    }
    @if (withName) {
      <span class="marker-name" [ngClass]="{ 'clickable': showButton }" (click)="showButton && !disabled ? select.emit() : null">{{marker.tag_name}}</span>
    }
    @if (showRemove) {
      <button
        class="remove-tag"
        (click)="remove.emit()"
        attr.aria-label="{{'feedback-creator_tag-remove' | translate}}">
        <i class="ficon-app-x"></i>
      </button>
    }
  </span>
} @else {
	<span class="ai-marker" [ngStyle]="{
		'background-color': '#' + (marker.category?.color || 'B1E9E4')
			}">
    <span class="ai-marker-icon">
			<i [attr.data-icon]="marker.category?.icon || 'e999d'" [ngStyle]="{
							'--icon-content': '\'\\' + (marker.category?.icon || 'e999d') + '\''
						}"></i>
    </span>
    <span class="ai-marker-name">{{marker.tag_name}}</span>
  </span>
}
